import React, { Component } from "react";
import { Button, Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import * as FileSaver from "file-saver";
import XLSX from "xlsx";
import * as moment from "moment";
import { MdOutlineAdd } from "react-icons/md";
import { Link } from "react-router-dom";

toast.configure();
class edocTypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MyApplicationList: [],
      deleteReferenceno: "",
      loading: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "eDoc Type",
    });
    this.GetListData("Draft");
  }

  GetListData = () => {
    try {
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/Admin/GeteDocType", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              MyApplicationList: data?.resultObject,
              loading: "Yes",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  viewRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/edoctype/view?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  editRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/edoctype/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "eDoc Types ID",
        header2: "eDoc Types",
        header3: "Applicable for",
        header4: "Seq no",
        header5: "Approvers",
        header6: "Modified By",
        header7: "Modified Date",
        header8: "Status",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            "Draft",
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.MyApplicationList?.forEach((value, index) => {
          let mdData = [
            value.approver,
            value.edoctype,
            value.employee,
            value.createdby,
            value.createddate
              ? moment(value.createddate).format("DD-MM-yyyy HH:mm:ss")
              : "",
            value.approvalstatus,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "draft.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  printRequest = (Referenceno) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/draft/print?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(Referenceno),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  render() {
    let dataArray = [];
    this.state.MyApplicationList?.map((value) => {
      let mdData = [
        value.eDocTypeId,
        value.eDocTypeName,
        value.applicablefor,
        // value.approverList,
        value.approverList,
        value.approverList,
        value.approverList,
        value.status,
      ];
      dataArray.push(mdData);
      return null;
    });

    const columns = [
      {
        name: "edoctypesid",
        label: "eDoc Types ID",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "edoctypes",
        label: "eDoc Types",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "applicablefor",
        label: "Applicable for",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      // {
      //   name: "Seqno",
      //   label: "Seq no",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     viewColumns: false,
      //     customBodyRender: (value, tableMeta, updateValue) => {
      //       return (
      //         <>
      //           {value?.map((dt) => (
      //             <div>{dt.seq}</div>
      //           ))}
      //         </>
      //       );
      //     },
      //   },
      // },
      {
        name: "approvers",
        label: "SequenceNo & Approvers",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                {value?.map((dt) => (
                  <div>{`${dt.seq}--${dt.employeeId}/${dt.employeeName}`}</div>
                ))}
              </>
            );
          },
        },
      },
      {
        name: "modifiedby",
        label: "Modified By",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                {tableMeta?.rowData?.[3]?.map((dt, index) => (
                  <div>{value?.length - 1 == index && dt.modifiedBy}</div>
                ))}
              </>
            );
          },
        },
      },
      {
        name: "modifieddate",
        label: "Modified Date",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                {value?.map((dt, index) => (
                  <div>
                    {value?.length - 1 == index &&
                      moment(dt.modifiedDate).format("DD-MM-yyyy HH:mm:ss")}
                  </div>
                ))}
              </>
            );
          },
        },
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <div
                  className={`badge ${
                    value === 1 ? "badge-approved" : "badge-danger"
                  }`}>
                  {value === 1 ? "Active" : "Inactive"}
                </div>
              </>
            );
          },
        },
      },

      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/awesome-eye.svg"
                  }
                  alt="View"
                  onClick={() =>
                    this.viewRequest(value, tableMeta, updateValue)
                  }
                  data-tip="View"
                />
                <img
                  className="action-right-space mouse-pointer"
                  style={{ width: "25px" }}
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/edit-solid.svg"
                  }
                  data-tip="Edit"
                  alt="Metro Flow Tree"
                  onClick={() =>
                    this.editRequest(value, tableMeta, updateValue)
                  }
                />
              </div>
            );
          },
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      download: false,
      print: true,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}>
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
            <Link to="/edoctype/create">
              <Button size="sm" color="primary">
                <MdOutlineAdd />
                Create
              </Button>
            </Link>
          </>
        );
      },
    };

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>eDoc Type</Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-xs-2">
          {" "}
          <MUIDataTable
            title={"eDoc Type"}
            data={dataArray}
            columns={columns}
            options={options}
          />{" "}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(edocTypeList);
